/* eslint-disable no-unsafe-optional-chaining */
import { INVESTMENT_STAGE_OPTIONS } from 'components/global/DealForm/_helpers/dealForm.consts';
import UniversalInput from 'components/global/UniversalInput';
import { Col, Row } from 'react-bootstrap';
import { $view } from 'signals/global.signals';

const InvestorPortfolioForm = () => (
  <Row>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="companyName"
        label="Company Name"
        placeholder="Enter name"
        required
      />
    </Col>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="teamId"
        label="Team"
        options={$view.value.teamOptions || []}
        type="select"
        placeholder="Select team"
        required
      />
    </Col>
    <h6 className="mb-16 text-gray-400 fw-bold">Company Details</h6>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="investmentStage"
        label="Company Investment Stage"
        options={INVESTMENT_STAGE_OPTIONS}
        type="select"
        placeholder="Select stage"
        required
      />
    </Col>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="raisedToDate"
        label="Raised To Date"
        placeholder="Enter raised to date"
        type="money"
        required
      />
    </Col>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="arr"
        label="Est Annual Revenue"
        placeholder="Enter valuation when invested"
        type="money"
        required
      />
    </Col>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="mrr"
        label="Est Monthly Revenue"
        placeholder="Enter current MRR"
        type="money"
        required
      />
    </Col>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="currentValuation"
        label="Current Valuation"
        placeholder="Enter current valuation"
        type="money"
        required
      />
    </Col>
    <h6 className="mb-16 text-gray-400 fw-bold">Our Holdings</h6>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="holdingsPct"
        label="Percentage Owned (approx)"
        placeholder="Enter percentage %"
        type="percent"
        max={100}
      />
    </Col>
    <Col sm={6}>
      <UniversalInput
        className="mb-16"
        name="holdingsValue"
        label="Value of Total Units Held"
        type="money"
        placeholder="$ Enter value"
      />
    </Col>
  </Row>
);

export default InvestorPortfolioForm;
